import React from "react";
import { Generatepinm } from "../../Model/Users"; //Include Home
import { Link } from "react-router-dom";
import { userprofile, Tvapppinvalidate } from "../../Model/Users"; //Include Home
import {
  SVGIcons,
  ImgIcons,
  withRouter,
  VirsionCheck,
} from "../../Helpers/Common";
import { Metadata } from "../Metadata/Metadata";
import Profilemenu from "../Profile_menu/Profilemenu";
import { Mobilemenu } from "../Mobile_menu/Mobilemenu";
import { isMobile } from "react-device-detect";
import BarLoader from "react-spinners/BarLoader";
var ImageData = "";
var SVGIcon = "";
ImgIcons().then((result) => (ImageData = result));
SVGIcons().then((resultData) => (SVGIcon = resultData));

class Activatemembership extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      SearchClick: false,
      userData: false,
      NotificationClick: false,
      showallbays: false,
      ButtonDisable: true,
      value: "",
      pin1: "",
      pin2: "",
      pin3: "",
      pin4: "",
      pin5: "",
      pin6: "",
      message: false,
      VirsionCheck: false,
      VirsionCheckDataloaded: false,
    };

    this.handleChange = this.handleChange.bind(this);
    this.submitVerifypinForm = this.submitVerifypinForm.bind(this);
  }

  componentDidMount() {
    VirsionCheck().then((vcheckres) => {
      let data = {
        seesionID: localStorage.getItem("session_id"),
        userID: localStorage.getItem("userID")
      }
      userprofile(data).then((userDatares) => {
        var userdata = JSON.parse(userDatares.data.message);
        if (userdata.success == false) {
          this.props.navigate("/createaccount");
        }
        if (userDatares.data.message == "session_expired") {
          //Redirect To login page.
          this.props.navigate("/createaccount");
        } else {
          var userDatares = JSON.parse(userDatares.data.message);
          this.setState({
            VirsionCheckData: vcheckres,
            VirsionCheckDataloaded: true,
            userData: userDatares.user_data,
            userchecked: userDatares.user_data?.is_child,
          });
        }
      });
    });
    if (localStorage.getItem("route") == "activate") {
      localStorage.removeItem("route", "activate");
    } else {
      localStorage.setItem("route", "activate");
    }
  }

  closebtn() {
    this.state.pin1 = "";
    this.state.pin2 = "";
    this.state.pin3 = "";
    this.state.pin4 = "";
    this.state.pin5 = "";
    this.state.pin6 = "";
    // const fields = this.state.PinField;
    // fields["pin1"] = "";
    // fields["pin2"] = "";
    // fields["pin3"] = "";
    // fields["pin4"] = "";
    // fields["pin5"] = "";
    // fields["pin6"] = "";
    this.setState({
      message: false,
    });
  }

  submitVerifypinForm(e) {
    e.preventDefault();
    let data = {
      seesionID: localStorage.getItem("session_id"),
      userID: localStorage.getItem("userID")
    }
    userprofile(data).then((userprofile) => {
      if (JSON.parse(userprofile.data.message).user_data) {
        var userdata = JSON.parse(userprofile.data.message).user_data;
      } else {
        this.props.navigate("/createaccount");
      }
      var postdata = {
        pin:
          this.state.pin1 +
          this.state.pin2 +
          this.state.pin3 +
          this.state.pin4 +
          this.state.pin5 +
          this.state.pin6,
        user_id: userdata.ID,
      };
      Tvapppinvalidate(postdata).then((response) => {
        if (response.status == 200) {
          var ResponseofTv = JSON.parse(response.data);
          this.setState({ message: ResponseofTv.msg });
          this.setState({ Errormessage: ResponseofTv.message });
        }
      });
    });
  }

  handleChange(value1, event) {
    // const fields = this.state.PinField;
    this.setState({
      IvalidpinMsg: "",
    });
    this.setState({ [value1]: event.target.value });
  }
  /*-----Logout Confirmation popup*/
  logoutconfirm() {
    this.setState({
      showconfirm: true,
    });
  }

  /*-------Logout-------*/
  Logout() {
    //Call logout Api
  }

  cancel() {
    //Call logout Api
    this.setState({
      showconfirm: false,
    });
  }

  inputfocus = (elmnt) => {
    if (elmnt.key === "Delete" || elmnt.key === "Backspace") {
      const next = elmnt.target.tabIndex - 2;
      if (next > -1) {
        elmnt.target.form.elements[next].focus();
      }
    } else {

      const next = elmnt.target.tabIndex;
      if (next < 6) {
        elmnt.target.form.elements[next].focus();
      }
    }
  };

  render() {
    if (this.state.VirsionCheckDataloaded == false) {
      // return <div className="loader"></div>;
      return (
        <div className="loader">
          <BarLoader color="#ff000f" />
        </div>
      );
    } else {
      //var GeneratepinData = JSON.parse(this.state.Pindata.data.message);

      // document.addEventListener("scroll", () => {
      //   const header = document.querySelector("header");
      //   if (window.scrollY > 10) {
      //     header.classList.add("head-hide");
      //   } else {
      //     header.classList.remove("head-hide");
      //   }
      // });
      // var Pinstate = this.state.PinField;

      if (
        this.state.pin1 &&
        this.state.pin2 &&
        this.state.pin3 &&
        this.state.pin4 &&
        this.state.pin5 &&
        this.state.pin6
      ) {
        var Button = false;
      } else {
        var Button = true;
      }

      return (
        <>
          <Metadata page="ACTIVATE-TV" />
          <>
            <header>
              <div className="mainNav pmenu dD-none">
                <div className="docubayBack white">
                  <Link to="/profile">
                    <img src={SVGIcon["back.svg"]} alt="DocuBay" />
                  </Link>
                  Activate TV
                </div>
              </div>
            </header>

            <main className="dD-none">
              <section className="mb-0">
                <div className="temp63">
                  <img src={ImageData["tv-pin.png"]} alt="TV Icons" />
                </div>
              </section>
              <section className="mb-0">
                <div className="temp64">
                  <h4>Type the code shown on your</h4>
                  <h3>TV and tap Verify</h3>
                </div>
              </section>
              {/* <section className="mb-0">
                <div className="temp65">
                  <img
                    src={ImageData["tv-pin-bg.png"]}
                    alt=""
                    className="w-100"
                  />
                  <div className="temp65-area">{GeneratepinData.pin}</div>
                </div>
              </section> */}
              {/* <section>
                <div className="temp66">
                  <a
                    onClick={() => {
                      this.regeneratepin();
                    }}
                  >
                    Regenerate PIN
                  </a>
                </div>
              </section> */}
              <form
                method="post"
                name="verifypin"
                onSubmit={this.submitVerifypinForm}
                noValidate="novalidate"
              >
                <section style={{ marginTop: 30 }} className="dD-none">
                  <div className="mobile-activate-code">
                    <div className="input-box">
                      <div className="activate-verify-code">
                        <input
                          type="tel"
                          name="pin1"
                          placeholder=""
                          className="text-center"
                          maxLength="1"
                          onKeyDown={this.keyDown}
                          value={this.state.pin1 || ""}
                          onChange={(e) => this.handleChange("pin1", e)}
                          tabIndex="1"
                          onKeyUp={(e) => this.inputfocus(e)}
                        />
                      </div>
                      <div className="activate-verify-code">
                        <input
                          type="tel"
                          name="pin2"
                          placeholder=""
                          className="text-center"
                          maxLength="1"
                          value={this.state.pin2 || ""}
                          onChange={(e) => this.handleChange("pin2", e)}
                          tabIndex="2"
                          onKeyUp={(e) => this.inputfocus(e)}
                        />
                      </div>
                      <div className="activate-verify-code">
                        <input
                          type="tel"
                          name="pin3"
                          placeholder=""
                          className="text-center"
                          maxLength="1"
                          value={this.state.pin3 || ""}
                          onChange={(e) => this.handleChange("pin3", e)}
                          tabIndex="3"
                          onKeyUp={(e) => this.inputfocus(e)}
                        />
                      </div>
                      <div className="activate-verify-code">
                        <input
                          type="tel"
                          name="pin4"
                          placeholder=""
                          className="text-center"
                          maxLength="1"
                          value={this.state.pin4 || ""}
                          onChange={(e) => this.handleChange("pin4", e)}
                          tabIndex="4"
                          onKeyUp={(e) => this.inputfocus(e)}
                        />
                      </div>
                      <div className="activate-verify-code">
                        <input
                          type="tel"
                          name="pin5"
                          placeholder=""
                          className="text-center"
                          maxLength="1"
                          value={this.state.pin5 || ""}
                          onChange={(e) => this.handleChange("pin5", e)}
                          tabIndex="5"
                          onKeyUp={(e) => this.inputfocus(e)}
                        />
                      </div>
                      <div className="activate-verify-code">
                        <input
                          type="tel"
                          name="pin6"
                          placeholder=""
                          className="text-center"
                          maxLength="1"
                          value={this.state.pin6 || ""}
                          onChange={(e) => this.handleChange("pin6", e)}
                          tabIndex="6"
                          onKeyUp={(e) => this.inputfocus(e)}
                        />
                      </div>
                    </div>
                    <div className="formField mt-24 mb-24">
                      {this.state.pin6 === "" || this.state.pin5 === "" || this.state.pin4 === "" || this.state.pin3 === "" || this.state.pin2 === "" || this.state.pin1 === "" ? this.state.Errormessage = "" : ""}
                      {this.state.Errormessage ? (
                        <div className="error" style={{ marginTop: "-10px", paddingBottom: "8px" }}>
                          <img src={SVGIcon["error.svg"]} alt="DocuBay" />
                          <p>{this.state.Errormessage} </p>
                        </div>
                      ) : null}
                      <button
                        type="submit"
                        id="sendEnquiryBtn"
                        disabled={Button}
                        className={Button ? "btn-black" : "btn-red"}
                      >
                        Verify
                      </button>
                    </div>
                  </div>
                </section>
              </form>
              {this.state.message ? (
                <div className="notification-box">
                  <div
                    className="passChangepopup sidemenucenteralign"
                    id="passChange"
                    style={{ display: "flex" }}
                  >
                    <div className="temp31-modal-body popup-animation">
                      <button className="temp31-modal-close temp31-modal-toggle">
                        <img
                          src={SVGIcon["promocode-close.svg"]}
                          alt="DocuBay"
                          onClick={() => {
                            this.closebtn();
                          }}
                        />
                      </button>
                      <img
                        src={ImageData["payment-succes.png"]}
                        alt="DocuBay"
                        className="imgPass"
                        style={{ height: "80px" }}
                      />
                      <div className="temp31-awesome">
                        <h5>{this.state.message}</h5>
                      </div>
                    </div>
                  </div>
                </div>
              ) : null}
            </main>
            <div className="profile-back-desk dD-block">
              <Link to="/">
                <div className="docubayBack white">
                  <img src={SVGIcon["back.svg"]} alt="DocuBay" />
                </div>
              </Link>
            </div>
            <main className="setting-main dD-block">
              <section className="mb-0">
                <div className="temp63">
                  <img src={ImageData["tv-pin.png"]} alt="TV Icons" />
                </div>
              </section>
              {/* <section className="mb-0">
                <div className="temp64">
                  <h4>Enter this PIN on your</h4>
                  <h3>
                    TV Screen <span> to get started</span>
                  </h3>
                </div>
              </section> */}
              <section className="mb-0">
                <div className="temp64">
                  <h4>Type the code shown on your</h4>
                  <h3>TV and tap Verify</h3>
                </div>
              </section>
              <section className="mb-0">
                <div className="temp65">
                  <form
                    method="post"
                    name="verifypin"
                    onSubmit={this.submitVerifypinForm}
                    noValidate="novalidate"
                  >
                    <div className="activate-membership">
                      <div className="pinInput1">
                        <div className="verify-code1">
                          <input
                            type="tel"
                            name="pin1"
                            placeholder=""
                            className="text-center"
                            maxLength="1"
                            onKeyDown={this.keyDown}
                            value={this.state.pin1 || ""}
                            onChange={(e) => this.handleChange("pin1", e)}
                            tabIndex="1"
                            onKeyUp={(e) => this.inputfocus(e)}
                          />
                        </div>
                        <div className="verify-code1">
                          <input
                            type="tel"
                            name="pin2"
                            placeholder=""
                            className="text-center"
                            maxLength="1"
                            value={this.state.pin2 || ""}
                            onChange={(e) => this.handleChange("pin2", e)}
                            tabIndex="2"
                            onKeyUp={(e) => this.inputfocus(e)}
                          />
                        </div>
                        <div className="verify-code1">
                          <input
                            type="tel"
                            name="pin3"
                            placeholder=""
                            className="text-center"
                            maxLength="1"
                            value={this.state.pin3 || ""}
                            onChange={(e) => this.handleChange("pin3", e)}
                            tabIndex="3"
                            onKeyUp={(e) => this.inputfocus(e)}
                          />
                        </div>
                        <div className="verify-code1">
                          <input
                            type="tel"
                            name="pin4"
                            placeholder=""
                            className="text-center"
                            maxLength="1"
                            value={this.state.pin4 || ""}
                            onChange={(e) => this.handleChange("pin4", e)}
                            tabIndex="4"
                            onKeyUp={(e) => this.inputfocus(e)}
                          />
                        </div>
                        <div className="verify-code1">
                          <input
                            type="tel"
                            name="pin5"
                            placeholder=""
                            className="text-center"
                            maxLength="1"
                            value={this.state.pin5 || ""}
                            onChange={(e) => this.handleChange("pin5", e)}
                            tabIndex="5"
                            onKeyUp={(e) => this.inputfocus(e)}
                          />
                        </div>
                        <div className="verify-code1">
                          <input
                            type="tel"
                            name="pin6"
                            placeholder=""
                            className="text-center"
                            maxLength="1"
                            value={this.state.pin6 || ""}
                            onChange={(e) => this.handleChange("pin6", e)}
                            tabIndex="6"
                            onKeyUp={(e) => this.inputfocus(e)}
                          />
                        </div>
                      </div>
                      {this.state.pin6 === "" || this.state.pin5 === "" || this.state.pin4 === "" || this.state.pin3 === "" || this.state.pin2 === "" || this.state.pin1 === "" ? this.state.Errormessage = "" : ""}
                      {this.state.Errormessage ? (
                        <div className="error" style={{ marginTop: "-10px", paddingBottom: "8px" }}>
                          <img src={SVGIcon["error.svg"]} alt="DocuBay" />
                          <p>{this.state.Errormessage}</p>
                        </div>
                      ) : null}
                      <button
                        type="submit"
                        id="sendEnquiryBtn"
                        // className="btn-red"
                        disabled={Button}
                        className={Button ? "btn-black" : "btn-red"}
                      >
                        Verify
                      </button>
                    </div>
                  </form>
                  {this.state.message ? (
                    <div className="notification-box">
                      <div
                        className="passChangepopup sidemenucenteralign"
                        id="passChange"
                        style={{ display: "flex" }}
                      >
                        <div className="temp31-modal-body popup-animation">
                          <button className="temp31-modal-close temp31-modal-toggle">
                            <img
                              src={SVGIcon["promocode-close.svg"]}
                              alt="DocuBay"
                              onClick={() => {
                                this.closebtn();
                              }}
                            />
                          </button>
                          <img
                            src={ImageData["payment-succes.png"]}
                            alt="DocuBay"
                            className="imgPass"
                            style={{ height: "80px" }}
                          />
                          <div className="temp31-awesome">
                            <h5>{this.state.message}</h5>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : null}
                </div>
              </section>
              {isMobile ? (
                <Mobilemenu
                  active="5"
                  versioncheck={this.state.VirsionCheckData}
                  profile={this.state.userData}
                />
              ) : (
                <Profilemenu
                  versioncheck={this.state.VirsionCheckData}
                  profile={this.state.userData}
                />
              )}
            </main>
          </>
        </>
      );
    }
  }
}
export default withRouter(Activatemembership);
